module.exports = __webpack_public_path__ + "img/branding01.ee158eb7.jpg";